// extracted by mini-css-extract-plugin
export default {"cancelText":"quotaFeatures__cancelText--gSlbk"};